import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-arrow-right\">\n<path d=\"M104.974,89.224L56.056,40.306c-5.401-5.401-5.401-14.159,0-19.56l0,0c5.401-5.401,14.159-5.401,19.56,0l68.478,68.478\n\tc5.399,5.399,5.399,14.152,0,19.551l-68.478,68.478c-5.401,5.401-14.159,5.401-19.56,0l0,0c-5.401-5.401-5.401-14.159,0-19.56\n\tl48.918-48.918C110.373,103.377,110.373,94.623,104.974,89.224z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow-right.svg
// module id = dxdv
// module chunks = 3